module.exports = __webpack_public_path__ + "static/media/ten_monkeys_kitchen.97c2dc02.png";